import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import "./SalesPopup.css"

function SalesPopup() {
  const [products, setProducts] = useState([])
  const [popup, setPopup] = useState(null)
  const navigate = useNavigate()

  // 1️⃣ API se real products fetch karna
  useEffect(() => {
    fetch("https://data.lacegota.in/api/products?per_page=15")
      .then(res => res.json())
      .then(data => {
        // Check if data is array
        if (Array.isArray(data)) {
          setProducts(data);
        }
      })
      .catch(err => console.error("Sales Popup API Error:", err));
  }, [])

  // 2️⃣ Random Popup Logic
  useEffect(() => {
    if (products.length === 0) return

    const cities = ["Delhi", "Mumbai", "Jaipur", "Surat", "Chennai", "Kolkata", "Ahmedabad", "Pune"]
    const times = ["2 minutes ago", "5 minutes ago", "10 minutes ago", "just now", "1 min ago"]

    const showPopup = () => {
      const randomProduct = products[Math.floor(Math.random() * products.length)]
      const randomCity = cities[Math.floor(Math.random() * cities.length)]
      const randomTime = times[Math.floor(Math.random() * times.length)]

      setPopup({
        name: randomProduct.name,
        image: randomProduct.images?.[0]?.src || "/placeholder.jpg",
        link: `/product/${randomProduct.slug}`,
        city: randomCity,
        time: randomTime
      })

      // 5 second baad popup gayab ho jaye
      setTimeout(() => setPopup(null), 5000)
    }

    // Har 10 se 15 second ke beech naya popup aaye
    const interval = setInterval(showPopup, 12000)

    // Pehla popup page load hone ke 4 second baad dikhao
    const initialTimeout = setTimeout(showPopup, 4000)

    return () => {
      clearInterval(interval)
      clearTimeout(initialTimeout)
    }
  }, [products])

  if (!popup) return null

  return (
    <div className="sales-popup" onClick={() => navigate(popup.link)}>
      <img src={popup.image} alt={popup.name} />
      <div className="sales-info">
        <p>Someone recently bought</p>
        <div className="product-name-box">
          <b>{popup.name}</b>
        </div>
        <small>{popup.time} • {popup.city}, India</small>
      </div>
      {/* Close button (Optional) */}
      <span className="close-x" onClick={(e) => { e.stopPropagation(); setPopup(null); }}>×</span>
    </div>
  )
}

export default SalesPopup;